<!-- Beta Mode Card -->
<ng-container *ngIf="isBeta; else normalCard">
  <div
    class="tw-flex tw-flex-col tw-p-6 tw-mx-auto tw-max-w-lg tw-text-center tw-text-gray-900 tw-bg-white dark:tw-bg-gray-800 tw-rounded-lg tw-border tw-border-gray-100 dark:tw-border-gray-400 tw-border-solid tw-shadow xl:tw-p-8 ">
    <h3 class="tw-text-2xl tw-font-semibold tw-mb-1 tw-text-dark-light-dynamic">
      Workforce.ai Subscription
    </h3>
    <p class="tw-font-light tw-text-gray-500 dark:tw-text-gray-400 tw-mt-0">
      Real-Time Workforce Intelligence
    </p>
    <div class="tw-flex tw-justify-center tw-items-baseline tw-my-6">
      <span class="tw-text-blue-500 tw-text-5xl tw-font-bold">Free</span>
      <span class="tw-text-gray-500 dark:tw-text-gray-300 tw-ml-2">while in Beta</span>
    </div>
    <ul role="list" class="tw-mb-4 tw-space-y-2 tw-text-left">
      <li class="tw-flex tw-items-center tw-space-x-3">
        <mat-icon class="tw-text-link-color-dynamic tw-shrink-0">check</mat-icon>
        <span class="tw-text-dark-light-dynamic">Analyze and benchmark any companies</span>
      </li>
      <li class="tw-flex tw-items-center tw-space-x-3">
        <mat-icon class="tw-text-link-color-dynamic tw-shrink-0">check</mat-icon>
        <span class="tw-text-dark-light-dynamic">
          Analyze arrivals, departures, churn, tenure, and more
        </span>
      </li>
      <li class="tw-flex tw-items-center tw-space-x-3">
        <mat-icon class="tw-text-link-color-dynamic tw-shrink-0">check</mat-icon>
        <span class="tw-text-dark-light-dynamic">Chart download capability</span>
      </li>
    </ul>

    <app-alert
      alertType="info"
      alertStyle="compact"
      hasBorder="false"
      customIcon="diamond_shine"
      class="tw-max-w-96 tw-mx-auto tw-mt-4">
      <p class="tw-my-0 tw-text-sm tw-mr-2">
        Enjoy full access to Workforce.ai features at no cost during our Beta period!
      </p>
    </app-alert>
  </div>
</ng-container>

<!-- Pricing Card -->
<ng-template #normalCard>
  <div
    class="tw-flex tw-flex-col tw-p-6 tw-mx-auto tw-max-w-lg tw-text-center tw-text-gray-900 tw-bg-white dark:tw-bg-gray-800 tw-rounded-lg tw-border tw-border-gray-100 dark:tw-border-gray-400 tw-border-solid tw-shadow xl:tw-p-8 ">
    <h3 class="tw-text-2xl tw-font-semibold tw-mb-1 tw-text-dark-light-dynamic">
      Workforce.ai Subscription
    </h3>
    <p class="tw-font-light tw-text-gray-500 dark:tw-text-gray-400 tw-mt-0">
      Real-Time Workforce Intelligence
    </p>

    <!-- Price -->
    <div class="tw-flex tw-justify-center tw-items-baseline tw-my-6">
      <span class="tw-text-gray-700 dark:tw-text-gray-300 tw-mr-2 tw-text-5xl tw-font-bold">
        ${{pricePerUser}}
      </span>
      <span class="tw-text-gray-500 dark:tw-text-gray-300">/month per user</span>
    </div>

    <!-- List -->
    <ul role="list" class="tw-mb-4 tw-space-y-2 tw-text-left">
      <li class="tw-flex tw-items-center tw-space-x-3">
        <mat-icon class="tw-text-link-color-dynamic tw-shrink-0">check</mat-icon>
        <span class="tw-text-dark-light-dynamic">Analyze and benchmark any companies</span>
      </li>
      <li class="tw-flex tw-items-center tw-space-x-3">
        <mat-icon class="tw-text-link-color-dynamic tw-shrink-0">check</mat-icon>
        <span class="tw-text-dark-light-dynamic">
          Analyze arrivals, departures, churn, tenure, and more
        </span>
      </li>
      <li class="tw-flex tw-items-center tw-space-x-3">
        <mat-icon class="tw-text-link-color-dynamic tw-shrink-0">check</mat-icon>
        <span class="tw-text-dark-light-dynamic">Chart download capability</span>
      </li>
    </ul>

    <!-- User Count -->
    <div class="tw-flex tw-gap-4 tw-justify-center tw-items-center tw-my-4">
      <label for="selectedQty" class="tw-font-medium tw-text-dark-light-dynamic">
        Number of users:
      </label>
      <ng-container *ngIf="isLoadingSubscriptions || isPollingForUpdate">
        <div class="tw-flex tw-justify-center tw-items-center tw-py-8">
          <mat-spinner diameter="50"></mat-spinner>
        </div>
      </ng-container>
      <div *ngIf="!isLoadingSubscriptions && !isPollingForUpdate" class="tw-flex tw-items-center">
        <button
          class="tw-text-lg tw-font-bold hover:tw-bg-gray-100 dark:hover:tw-bg-gray-700 tw-transition-all
        tw-border tw-border-solid tw-border-gray-200 dark:tw-border-gray-600 tw-bg-white dark:tw-bg-gray-800 tw-text-dark-light-dynamic tw-rounded tw-h-8 tw-w-8 tw-flex tw-items-center tw-justify-center"
          (click)="decrementUsers()">
          -
        </button>
        <span
          class="tw-text-xl tw-font-semibold tw-text-dark-light-dynamic tw-mx-4"
          id="selectedQty">
          {{ selectedQty }}
        </span>
        <button
          class="tw-text-lg tw-font-bold hover:tw-bg-gray-100 dark:hover:tw-bg-gray-700 tw-transition-all
      tw-border tw-border-solid tw-border-gray-200 dark:tw-border-gray-600 tw-bg-white dark:tw-bg-gray-800 tw-text-dark-light-dynamic tw-rounded tw-h-8 tw-w-8 tw-flex tw-items-center tw-justify-center"
          (click)="incrementUsers()">
          +
        </button>
      </div>
    </div>

    <!-- Total Price -->
    <div
      *ngIf="!currentSubscription"
      class="tw-flex tw-justify-center tw-gap-2 tw-items-end tw-my-6">
      <span class="tw-font-medium tw-text-dark-light-dynamic tw-mb-1">Total Price:</span>
      <div
        class="tw-text-3xl tw-font-bold tw-text-primary_purple-600 dark:tw-text-primary_purple-500">
        {{ totalCost | currency:'USD':'symbol':'1.0-0' }}
        <span class="tw-text-gray-500 dark:tw-text-gray-300 tw-font-normal tw-text-base">
          /billed monthly
        </span>
      </div>
    </div>

    <ng-container
      *ngIf="currentSubscriptionQty !== null && selectedQty === 0 && (isOrgAdmin$ | async)">
      <app-alert alertType="warning">
        Canceling your subscription will take effect at the end of your current billing period.
      </app-alert>
      <a
        (click)="cancelSubscription()"
        class="tw-mt-6 tw-text-white tw-shrink-0 tw-relative tw-inline-flex tw-items-center tw-justify-center tw-overflow-hidden tw-text-sm tw-rounded-md tw-bg-gradient-to-br tw-from-purple-600 tw-to-blue-600 hover:tw-from-blue-600 hover:tw-to-purple-600 focus:tw-outline-none focus:tw-ring-blue-500 tw-transition-all tw-p-0.5 tw-cursor-pointer">
        <span class="tw-relative tw-w-full tw-px-5 tw-py-2.5 tw-rounded-md tw-font-semibold">
          Cancel Subscription
        </span>
      </a>
    </ng-container>

    <ng-container
      *ngIf="currentSubscriptionQty !== null && selectedQty !== 0 && (isOrgAdmin$ | async)">
      <app-alert alertType="info" *ngIf="currentSubscriptionQty !== selectedQty">
        Changing the seats will take effect immediately and your charges will be prorated.
      </app-alert>
      <a
        [ngClass]="{
        'tw-opacity-50': !allowChangeSubscription(),
        'tw-cursor-not-allowed': !allowChangeSubscription(),
        'tw-cursor-pointer': allowChangeSubscription()
      }"
        (click)="allowChangeSubscription() && updateSubscription()"
        [attr.disabled]="!allowChangeSubscription()"
        class="tw-mt-6 tw-text-white tw-shrink-0 tw-relative tw-inline-flex tw-items-center tw-justify-center tw-overflow-hidden tw-text-sm tw-rounded-md tw-bg-gradient-to-br tw-from-purple-600 tw-to-blue-600 hover:tw-from-blue-600 hover:tw-to-purple-600 focus:tw-outline-none focus:tw-ring-blue-500 tw-transition-all tw-p-0.5 tw-cursor-pointer">
        <span class="tw-relative tw-w-full tw-px-5 tw-py-2.5 tw-rounded-md tw-font-semibold">
          Change Subscription
        </span>
      </a>
      <div class="tw-pt-4">
        <a (click)="cancelSubscription()" class="tw-text-red-500 tw-text-sm">Cancel Subscription</a>
      </div>
    </ng-container>

    <ng-container *ngIf="currentSubscriptionQty === null && (isOrgAdmin$ | async)">
      <a
        (click)="selectedQty && subscribe()"
        [ngClass]="{
        'tw-opacity-50': !selectedQty,
        'tw-cursor-not-allowed': !selectedQty,
        'tw-cursor-pointer': selectedQty
      }"
        class="tw-mt-6 tw-text-white tw-shrink-0 tw-relative tw-inline-flex tw-items-center tw-justify-center tw-overflow-hidden tw-text-sm tw-rounded-md tw-bg-gradient-to-br tw-from-purple-600 tw-to-blue-600 hover:tw-from-blue-600 hover:tw-to-purple-600 focus:tw-outline-none focus:tw-ring-blue-500 tw-transition-all tw-p-0.5">
        <span class="tw-relative tw-w-full tw-px-5 tw-py-2.5 tw-rounded-md tw-font-semibold">
          Subscribe
        </span>
      </a>
    </ng-container>

    <ng-container *ngIf="!(isOrgAdmin$ | async)">
      <app-alert alertType="info">
        You must be an administrator to manage your subscription.
      </app-alert>
    </ng-container>
  </div>
</ng-template>
